import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
import { languages } from 'src/app/shared/languages';

@Component({
  standalone: false,
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
  languages: any[];
  translatedLanguages: any[] = [];
  country: string;

  constructor(public translate: TranslateService, private cdr: ChangeDetectorRef,
    @Inject('LANGUAGES') languages: any[]
  ) { 
    this.languages = languages;
    this.country = sessionStorage.getItem('country') || 'ES';
    if (this.country === 'BE') {
      this.languages = this.languages.filter(lang => lang.code !== 'es_ES' && lang.code !== 'pt_PT');
    }
  }

  loadTranslations(): void {
    this.translatedLanguages = [];
    this.languages.forEach(language => {
      this.translate.get(language.name).subscribe((res: string) => {
        this.translatedLanguages.push({ code: language.code, name: res });
      });
    });
  }

  ngOnInit(): void {
    this.loadTranslations();
    const storedLang = sessionStorage.getItem('language');
    const defaultLang = storedLang || this.translate.getDefaultLang();
    this.translate.use(defaultLang);
  }

  changeLanguage(lang: string): void {
    if (sessionStorage.getItem('country') === 'BE') {
      this.languages = this.languages.filter(lang => lang.code !== 'es_ES' && lang.code !== 'pt_PT');
    }
    this.translate.use(lang);
    this.loadTranslations();
    sessionStorage.setItem('language', lang);
    document.documentElement.lang = lang.substring(0, 2);;
    this.cdr.detectChanges();
  }

}
